import { render, staticRenderFns } from "./NuevaVenta.vue?vue&type=template&id=4bd3e15b&scoped=true"
import script from "./NuevaVenta.vue?vue&type=script&lang=js"
export * from "./NuevaVenta.vue?vue&type=script&lang=js"
import style0 from "./NuevaVenta.vue?vue&type=style&index=0&id=4bd3e15b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd3e15b",
  null
  
)

export default component.exports